import * as React from 'react';

import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'

import { confirmable, ConfirmDialogProps, createConfirmation } from 'react-confirm';

export interface Props {
    okLabel?: string;
    cancelLabel?: string;
    title?: string;
    confirmation?: string;
};

const Confirmation: React.FC<ConfirmDialogProps<Props, boolean>> = (props) => (
    <Modal centered show={props.show} onHide={() => props.proceed(false)} backdrop={true}>
        <Modal.Header>
            <Modal.Title className="fs-6 fw-semibold">{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-0 text-secondary">
            {props.confirmation}
        </Modal.Body>
        <Modal.Footer>
            <Button className="btn-ghost" variant="" onClick={() => props.proceed(false)}>{props.cancelLabel || 'Cancel'}</Button>
            <Button variant='danger' autoFocus onClick={() => props.proceed(true)}>{props.okLabel || 'OK'}</Button>
        </Modal.Footer>
    </Modal>
);

Confirmation.defaultProps = {
    title: undefined,
    confirmation: undefined,
    okLabel: 'Delete',
    cancelLabel: 'Cancel',
    show: undefined,
    proceed: undefined,
    cancel: undefined,
    dismiss: undefined,
};

export default function confirm(title: string, confirmation: string, options: Props = {}) {
    return createConfirmation(confirmable(Confirmation))({ title, confirmation, ...options });
}
